<template>
  <div style="height: 60vh">
    <el-row style="padding-bottom: 10px;">
      <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24"
              style="line-height:40px;height:40px;background-color:#042340;text-align: center;margin-right: 10px;">
        {{ form.name }}
      </el-col>
    </el-row>
    <el-row style="color: rgb(216, 228, 106);margin: 10px 0 10px 40px;">* 启用后将应用于该类型下该型号的所有设备</el-row>
    <ul class="visualUl">
      <li :key="item.id" @touchstart="clickChange(item)" @click="clickChange(item)" class="visualLi" v-for="item in tableData">
        <div style="height: 180px;position: relative;">
          <img :src="$ftpUrl + item.imgUrl" class="visualImg" v-if="item.imgUrl">
          <div class="iconDiv ableImg" v-if="option === item.id">启用</div>
          <div class="iconDiv disabledImg" v-else>禁用</div>
        </div>
        <div class="caption" style="text-align: center; font-weight:bold; margin-top: 10px;">{{ item.cnName }}</div>
      </li>
    </ul>

  </div>
</template>

<script>
import {listByModelId} from "@/network/device-model-visual";

export default {
  name: "VisualEdit",
  props: {
    deviceInfo: {},
  },
  data() {
    return {
      tableData: [],
      option: '',
      form: {
        name: this.deviceInfo.name,
        note: this.deviceInfo.note
      }
    }
  },
  mounted() {
    this.listByModelId();
  },
  methods: {
    listByModelId() {
      this.tableData = [];
      listByModelId(this.deviceInfo.modelId).then(res => {
        if (res.code === 0) {
          this.option = this.deviceInfo.visualId;
          console.log(this.option, this.deviceInfo);
          this.tableData = res.data;
        }
      })
    },
    clickChange(val) {
      this.option = val.id;
      this.$emit("receiveData", this.option)
    }
  }
}
</script>

<style scoped>
.visualUl {
  list-style: none;
}

.visualLi {
  width: 300px;
  height: 220px;
  float: left;
  margin-right: 30px;
  border: 1px solid rgba(41, 155, 255, .1);
  background-color: rgba(41, 155, 255, .1);
}

.visualImg {
  width: 90%;
  height: 180px;
  margin: 10px 5%;
}

.iconDiv {
  width: 46px;
  height: 55px;
  line-height: 40px;
  text-align: center;
  position: absolute;
  top: 0;
}

.disabledImg {
  background-image: url("../../../../../assets/images/sys-setting/large-size-screen/1.png");
}

.ableImg {
  background-image: url("../../../../../assets/images/sys-setting/large-size-screen/0.png");
}
</style>
